module.exports = "../content/549ff276c21f32d958a3be77aff25d4f.woff2";